// Import model
import { AiEmbeddedContent } from '../models/AiEmbeddedContent';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for AiEmbeddedContent - handles JSON serialization and deserialization with type validation
 */
export class AiEmbeddedContentSerializer {
  /**
   * Deserializes a JSON string into a AiEmbeddedContent instance
   */
  static deserialize(json: string): AiEmbeddedContent {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a AiEmbeddedContent instance
   */
  static fromObject(obj: any): AiEmbeddedContent {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to AiEmbeddedContent');
    }


    const instance: AiEmbeddedContent = {
      content: obj['Content'] as string | undefined,
      contentType: obj['ContentType'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of AiEmbeddedContent instances
   */
  static deserializeArray(json: string): AiEmbeddedContent[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a AiEmbeddedContent instance to a JSON string
   */
  static serialize(instance: AiEmbeddedContent): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a AiEmbeddedContent instance to a plain object
   */
  static toObject(instance: AiEmbeddedContent): any {
    return {
      'Content': instance.content,
      'ContentType': instance.contentType,
    };
  }

  /**
   * Serializes an array of AiEmbeddedContent instances to a JSON string
   */
  static serializeArray(instances: AiEmbeddedContent[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
